import React from 'react';
import { Box, Typography } from '@mui/material';

interface EmailImageProps {
  language: 'en' | 'de';
}

export const EmailImage: React.FC<EmailImageProps> = ({ language }) => {

  return (
    <Box sx={{ textAlign: 'center', my: 2 }}>
      <Box
        sx={{
          maxWidth: '350px',
          mx: 'auto',
          userSelect: 'none',
          WebkitUserSelect: 'none',
          MozUserSelect: 'none',
          msUserSelect: 'none',
        }}
        component="span"
        role="text"
        aria-label="email address"
      >
        <Typography
          variant="body2"
          sx={{
            fontFamily: 'monospace',
            color: 'primary.main',
            fontWeight: 600,
            pointerEvents: 'none',
            '&::selection': {
              backgroundColor: 'transparent',
            },
            '&::-moz-selection': {
              backgroundColor: 'transparent',
            },
          }}
        >
          annesophiesarah(at)googlemail.com
        </Typography>
      </Box>
    </Box>
  );
};
